
  import { defineComponent } from 'vue';

  import constants from '@/common/constants';
  import security from '@/common/mixins/security';

  import AggregatedPageWrapper from '../components/common/AggregatedPageWrapper.vue';
  import { TExportConfig } from '../components/common/ved-aggregated-export-buttons/types';
  import ProductAggregatedBaseInfo from '../components/product-aggregated/ProductAggregatedBaseInfo.vue';
  import ProductAggregatedFilter from '../components/product-aggregated/ProductAggregatedFilter.vue';
  import ProductAggregatedTable from '../components/product-aggregated/ProductAggregatedTable.vue';
  import { SelectTypes, TreeCountryValues, TreeRegionRFValues } from '../types/common-aggregated';
  import { TAggregatedPermissions } from '../types/permission';
  import type { TProductAggregatedFilter } from '../types/product-aggregated';
  import { getFilenameWithPeriod } from '../utils/filename';

  import links from '@/utils/links';

  const DEFAULT_FILTER: TProductAggregatedFilter = {
    periods: ['2021'],
    countries: [TreeCountryValues.ARMENIA_99],
    regionsRf: [TreeRegionRFValues.RF],
    selectTypeId: SelectTypes.CUMULATIVE_TOTAL,
    amountSigns: 0,
  };

  export default defineComponent({
    name: 'ProductAggregated',
    components: {
      AggregatedPageWrapper,
      ProductAggregatedFilter,
      ProductAggregatedBaseInfo,
      ProductAggregatedTable,
    },
    mixins: [security],
    data(): {
      filter: TProductAggregatedFilter;
      filterForExport: TProductAggregatedFilter;
      defaultFilter: TProductAggregatedFilter;
    } {
      return {
        filter: { ...DEFAULT_FILTER },
        filterForExport: { ...DEFAULT_FILTER },
        defaultFilter: { ...DEFAULT_FILTER },
      };
    },
    mounted() {
      this.checkPermissionAndRedirect(this.getPermissions.view);
    },
    computed: {
      getPermissions(): TAggregatedPermissions {
        return {
          view: constants.Permissions.ForeignTradeAnalyticsAggregatedByProductsView,
          build: constants.Permissions.ForeignTradeAnalyticsAggregatedByProductsBuild,
          export: constants.Permissions.ForeignTradeAnalyticsAggregatedByProductsDownload,
        };
      },

      getExportConfig(): TExportConfig {
        return {
          pdfFileName: this.getFileName(this.filter),
          excelFileName: this.getFileName(this.filterForExport),
          excel: {
            permissionCode: this.getPermissions.export,
            url: links.ved.productAggregated.exportExcel,
            params: this.filterForExport,
          },
        };
      },
    },
    methods: {
      searchFilter(filter: Partial<TProductAggregatedFilter>) {
        this.filter = { ...this.filter, ...filter };
      },
      updateFilter(filter: Partial<TProductAggregatedFilter>) {
        this.filterForExport = { ...this.filterForExport, ...filter };
      },
      getFileName(filter: TProductAggregatedFilter) {
        return getFilenameWithPeriod('Агрегированные_данные_в_разрезе_товаров', filter.periods);
      },
    },
  });
